import { CourseDiffsAndGapPlansTableCtrl } from './course-diffs-and-gap-plans-table.controller';

export const CourseDiffsAndGapPlansTable = {
  bindings: {
    courseDiffs: '<',
    gapPlans: '<',
    currentSchool: '<',
  },
  template: require('./course-diffs-and-gap-plans-table.html'),
  controller: CourseDiffsAndGapPlansTableCtrl,
};
